export default __webpack_public_path__ + "static/media/The Serpent's Pull.6e7905ec.jpg";